import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'AboutPage',
        name: '关于我们 - 韩漫画免费阅读',
        description: 'ManhwaFun是一个专注韩国漫画免费阅读的平台，提供下拉式阅读体验和海量韩国漫画资源。',
        isPartOf: { '@type': 'WebSite', name: 'ManhwaFun' },
      },
      {
        '@type': 'Organization',
        name: 'ManhwaFun',
        url: 'http://costrebate.com/',
        description: '韩国漫画网站 - 韩漫画免费阅读平台，提供下拉式阅读体验。',
        foundingDate: '2024',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          email: 'hello@costrebate.com',
          availableLanguage: ['Chinese'],
        },
        sameAs: ['http://costrebate.com/'],
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'http://costrebate.com/' },
          { '@type': 'ListItem', position: 2, name: '关于我们', item: 'http://costrebate.com/about' },
        ],
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '这个网站收费吗？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'ManhwaFun 是一个免费的韩漫阅读平台，所有漫画资源均可免费在线阅读，无需付费订阅。',
            },
          },
          {
            '@type': 'Question',
            name: '什么是下拉式阅读？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '下拉式阅读是专为手机和网页优化的竖向滚动阅读模式，无需翻页，直接向下滑动即可连续阅读漫画内容，体验流畅舒适。',
            },
          },
          {
            '@type': 'Question',
            name: '漫画更新频率如何？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '我们尽力同步韩国最新的连载进度，热门作品的更新基本与韩国保持同步，通常在原作发布后24小时内完成更新。',
            },
          },
          {
            '@type': 'Question',
            name: '支持哪些设备阅读？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'ManhwaFun 支持所有主流设备，包括电脑、平板和手机，在任何浏览器中均可流畅阅读，无需下载额外软件。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 韩漫画免费阅读_韩国漫画网站"
        description="ManhwaFun是一个专注韩国漫画免费阅读的平台，提供下拉式阅读体验和海量韩国漫画资源。了解更多关于我们的品牌故事、读者口碑和联系方式。"
        keywords="关于我们,韩漫画免费阅读,韩国漫画网站,看漫画下拉式"
        canonical="http://costrebate.com/about"
        ogTitle="关于我们 - 韩漫画免费阅读"
        ogDescription="了解ManhwaFun的品牌故事，专注韩国漫画免费阅读的平台。"
        ogUrl="http://costrebate.com/about"
        schemaData={schemaData}
      />

      <Navbar transparent={false} />

      <main className="pt-16 md:pt-18">
        {/* Breadcrumb */}
        <div className="bg-background-50 border-b border-background-200">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
            <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-400" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700 font-medium">关于我们</span>
            </nav>
          </div>
        </div>

        {/* Brand Introduction */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
              <div className="lg:w-2/5">
                <span className="inline-block px-3 py-1.5 rounded-full text-xs font-medium border border-primary-300 text-primary-600 mb-4">
                  关于我们
                </span>
                <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20cozy%20reading%20corner%2C%20bookshelf%20with%20comics%2C%20warm%20ambient%20lighting%2C%20comfortable%20seat%2C%20soft%20peach%20and%20cream%20tones%2C%20peaceful%20atmosphere%2C%20illustrative%20style%2C%20reading%20nook%2C%20cultural%20vibe%2C%20modern%20interior&width=900&height=1200&seq=about-illustration&orientation=portrait"
                    alt="关于韩漫画免费阅读平台"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="lg:w-3/5">
                <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
                  品牌介绍
                </h1>
                <p className="mt-5 text-sm md:text-base text-foreground-500 leading-relaxed max-w-lg">
                  ManhwaFun 诞生于一群韩漫爱好者的热情——我们希望打造一个让所有韩漫迷都能轻松享受的阅读空间。
                  在这里，<strong>韩漫画免费阅读</strong>不再是奢望，<strong>看漫画下拉式</strong>的流畅体验让追更变成一种享受。
                </p>
                <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed max-w-lg">
                  平台收录了海量<strong>好看的韩国漫画大全</strong>，从热门恋爱到热血战斗，从悬疑推理到搞笑日常，
                  我们的<strong>韩国漫画网站</strong>每天更新，确保你不会错过任何精彩内容。
                </p>
                <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed max-w-lg">
                  下拉式阅读是我们最引以为豪的特色——专为移动时代设计，告别传统翻页的繁琐，一滑到底，
                  看漫画就像刷短视频一样流畅自然。无论你是在通勤路上，还是睡前放松，ManhwaFun 都是你最好的韩漫伴侣。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Platform Stats */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              <div className="relative overflow-hidden rounded-xl bg-foreground-950 p-6 md:p-8">
                <div className="absolute top-0 right-0 w-24 h-24 bg-accent-500/10 rounded-bl-full"></div>
                <div className="relative z-10">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/10 mb-4">
                    <i className="ri-book-open-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-2">5000+</h3>
                  <p className="text-sm text-white/50">收录韩国漫画作品，持续增长中</p>
                </div>
              </div>

              <div className="relative overflow-hidden rounded-xl p-6 md:p-8">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20community%20reading%20scene%2C%20multiple%20readers%20enjoying%20comics%2C%20warm%20atmosphere%2C%20soft%20peach%20background%2C%20illustrative%20style%2C%20modern%20casual%20setting&width=600&height=400&seq=stat-card-02&orientation=landscape"
                  alt="百万读者社区"
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/40"></div>
                <div className="relative z-10">
                  <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-white/20 backdrop-blur-sm text-white mb-4">
                    <i className="ri-group-line mr-1"></i>读者社区
                  </span>
                  <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-2">300万+</h3>
                  <p className="text-sm text-white/70">月活跃读者，口碑相传</p>
                </div>
              </div>

              <div className="relative overflow-hidden rounded-xl bg-background-50 p-6 md:p-8">
                <div className="mb-4">
                  <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-1">4.8</h3>
                  <p className="text-sm text-foreground-400">用户综合评分</p>
                </div>
                <div className="aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20rating%20stars%20concept%2C%20happy%20readers%2C%20five%20star%20review%2C%20warm%20peach%20background%2C%20illustrative%20style%2C%20positive%20vibe%2C%20soft%20lighting%2C%20clean%20composition&width=600&height=450&seq=stat-card-03&orientation=landscape"
                    alt="用户好评"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-3">
                <i className="ri-question-line mr-1"></i>常见问题
              </span>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
                读者常问
              </h2>
            </div>

            <div className="space-y-3">
              {[
                { q: '这个网站收费吗？', a: 'ManhwaFun 是一个免费的韩漫阅读平台，所有漫画资源均可免费在线阅读，无需付费订阅。我们通过广告收入维持运营，始终将为韩漫爱好者提供免费的阅读体验作为第一准则。' },
                { q: '什么是下拉式阅读？', a: '下拉式阅读是专为手机和网页优化的竖向滚动阅读模式。与传统的左右翻页不同，你只需要向下滑动屏幕，漫画内容就会像瀑布一样连续呈现。这种方式更符合手机使用习惯，阅读体验更流畅舒适。' },
                { q: '漫画更新频率如何？', a: '我们尽力同步韩国最新的连载进度。热门作品的更新基本与韩国保持同步，通常在原作发布后24小时内完成更新。非热门作品也会根据源站更新节奏及时跟进。' },
                { q: '支持哪些设备阅读？', a: 'ManhwaFun 支持所有主流设备——电脑、平板、手机均可流畅阅读。无需下载任何 App 或额外软件，只要打开浏览器就能享受高清韩漫阅读体验。' },
                { q: '为什么有些漫画加载慢？', a: '为了提供高清画质的阅读体验，每张漫画图片都保持了较高的分辨率。如果遇到加载慢的情况，建议检查网络连接，或稍等片刻让图片缓存完成，后续阅读会更加流畅。' },
              ].map((faq, index) => (
                <details key={index} className="group bg-background-100 rounded-xl overflow-hidden">
                  <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                    <span className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                      {faq.q}
                    </span>
                    <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                    <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                  </summary>
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" className="py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3">
                <i className="ri-mail-line mr-1"></i>与我们联系
              </span>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
                联系方式
              </h2>
              <p className="mt-2 text-sm text-foreground-500">
                有任何问题或建议，欢迎随时联系我们
              </p>
            </div>

            <div className="max-w-lg mx-auto">
              <div className="bg-background-50 rounded-2xl p-6 md:p-8 space-y-5">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100">
                    <i className="ri-mail-line text-primary-500"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">电子邮箱</p>
                    <p className="text-sm text-foreground-500">hello@costrebate.com</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100">
                    <i className="ri-wechat-line text-secondary-500"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">微信公众号</p>
                    <p className="text-sm text-foreground-500">ManhwaFun韩漫</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100">
                    <i className="ri-weibo-line text-accent-500"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">微博</p>
                    <p className="text-sm text-foreground-500">@ManhwaFun韩漫</p>
                  </div>
                </div>
              </div>

              <div className="mt-8 text-center">
                <Link
                  to="/"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
                >
                  <i className="ri-home-line"></i>
                  返回首页开始阅读
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}